import { ServiceGroup } from './ServiceGroup.interface';
import { Service } from '@models/Service/Service.interface';
import { ServiceModel } from '@models/Service/Service.model';
import { MarkModel } from '../Mark/Mark.model';
import { Mark } from '../Mark/Mark.interface';

export class ServiceGroupModel implements ServiceGroup {
  id: number;
  parentId?: number;
  title: string;
  marks: Mark[];
  isPopularGlobal: boolean;
  children?: Service[] | null;
  routePath: string;
  openedRoutePath: string;

  constructor(data: any) {
    this.id = data.id ? data.id : null;
    this.parentId = data.parentId ? data.parentId : null;
    this.title = data.entity && data.entity.title ? data.entity.title : '';
    this.marks = [];
    if (data.entity && data.entity.marks) {
      data.entity.marks.forEach((mark: any) =>
        this.marks.push(new MarkModel(mark))
      );
    }
    this.children = [];
    this.isPopularGlobal = data.isPopularGlobal ? data.isPopularGlobal : false;
    this.routePath = data.routePath ? data.routePath : false;
    this.openedRoutePath = data.openedRoutePath ? data.openedRoutePath : false;
    if (data.children && data.children.length) {
      data.children.forEach((service: any) => {
        service.routePath =
          data.routePath +
          `${data.routePath.substr(-1, 1) === '/' ? '' : '/'}` +
          service.id +
          '/';
        service.openedRoutePath = data.routePath;
        this.children!.push(
          new ServiceModel({
            ...service,
            isPopularGlobal: this.isPopularGlobal,
          })
        );
      });
    }
  }
}
